var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgArrowRightDown = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.15953 6.15956C6.55006 5.76904 7.18322 5.76904 7.57375 6.15956L16.1333 14.7191L16.1333 7.87187C16.1333 7.31958 16.581 6.87187 17.1333 6.87187C17.6856 6.87187 18.1333 7.31958 18.1333 7.87187L18.1333 17.1333C18.1333 17.6856 17.6856 18.1333 17.1333 18.1333H7.87187C7.31958 18.1333 6.87187 17.6856 6.87187 17.1333C6.87187 16.581 7.31958 16.1333 7.87187 16.1333H14.7191L6.15953 7.57378C5.76901 7.18325 5.76901 6.55009 6.15953 6.15956Z",
    fill: "currentColor"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgArrowRightDown);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ArrowRightDown.7aeb2c3c8aa109f22a0af31d9c4bab95.svg";